export default __webpack_public_path__ + "static/media/vission.1531ee72.png";